import React from "react";
import { Link } from "react-router-dom";
import { Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell } from "@sainsburys-tech/fable";
import PropTypes from "prop-types";
import moment from "moment";
import Badge from "../Badge";

const parseDate = date => {
  return (date && moment(date).format("HH:mm, Do MMM YYYY")) || "Never";
};

const storeBadge = date => {
  if (!date) {
    return null;
  }
  if (
    moment(date) >
    moment()
      .startOf("day")
      .subtract(14, "days")
  ) {
    return <Badge title="ELS" />;
  }
  return null;
};

const StoresTable = props => (
  <React.Fragment>
    {props.stores.length > 0 ? (
      <Table isResponsive={true} layout="fixed">
        <TableHeader>
          <TableRow>
            <TableHeaderCell>Store Id</TableHeaderCell>
            <TableHeaderCell>Name</TableHeaderCell>
            <TableHeaderCell>Last Gateway Heartbeat</TableHeaderCell>
            <TableHeaderCell>First Commissioned</TableHeaderCell>
            <TableHeaderCell>Latest Acknowledged Schedule</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {props.stores.map((store, index) => (
            <TableRow key={index}>
              <TableCell>{store.storeId}</TableCell>
              <TableCell>
                <span>
                  <Link to={`/stores/${store.storeId}`}>{store.name}</Link>
                  <span className="fable:ml-4">
                    {storeBadge(store.firstCommissioned)}
                  </span>
                </span>
              </TableCell>
              <TableCell>{parseDate(store.lastGatewayHeartbeat)}</TableCell>
              <TableCell>{parseDate(store.firstCommissioned)}</TableCell>
              <TableCell>{parseDate(store.latestAcknowledgedSchedule)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    ) : (
      <span>No stores</span>
    )}
  </React.Fragment>
);

StoresTable.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      storeId: PropTypes.string,
      name: PropTypes.string,
      lastGatewayHeartbeat: PropTypes.string,
      firstCommissioned: PropTypes.string,
      latestAcknowledgedSchedule: PropTypes.string
    })
  )
};

export default StoresTable;
